import { render, staticRenderFns } from "./PorEquipeAcs.vue?vue&type=template&id=164bf651"
import script from "./PorEquipeAcs.vue?vue&type=script&lang=js"
export * from "./PorEquipeAcs.vue?vue&type=script&lang=js"
import style0 from "./PorEquipeAcs.vue?vue&type=style&index=0&id=164bf651&prod&lang=css"
import style1 from "./PorEquipeAcs.vue?vue&type=style&index=1&id=164bf651&prod&lang=css"
import style2 from "./PorEquipeAcs.vue?vue&type=style&index=2&id=164bf651&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports